import { EVENT_TYPES as STANDARD_EVENT_TYPES } from '@stepstone/events-js';
import { showStepModalThunk } from './stepModalSlice.js';
import { FORM_TYPES } from '../../../types/paramsConfig.js';
import { initCommonStepModalsDependencies } from './initCommonStepModalsDependencies.js';
const EVENT_TYPES = {
    SHOW_LOGIN_MODAL: STANDARD_EVENT_TYPES.CANDIDATE_PROFILE_EVENTS.SHOW_LOGIN_MODAL,
    SHOW_REGISTRATION_MODAL: STANDARD_EVENT_TYPES.CANDIDATE_PROFILE_EVENTS.SHOW_REGISTRATION_MODAL,
    SHOW_FULLSCREEN_RLA_MODAL: STANDARD_EVENT_TYPES.CANDIDATE_PROFILE_EVENTS.SHOW_FULLSCREEN_RLA_MODAL,
    HIDE_FULLSCREEN_RLA_MODAL: STANDARD_EVENT_TYPES.CANDIDATE_PROFILE_EVENTS.HIDE_FULLSCREEN_RLA_MODAL,
    INTERNAL_EVENTS: {
        SHOW_TWO_STEP_MODAL: 'INTERNAL_EVENTS_SHOW_TWO_STEP_MODAL',
        HIDE_TWO_STEP_MODAL: 'INTERNAL_EVENTS_HIDE_TWO_STEP_MODAL',
    },
};
export const getSubscriptionEvents = ({ showTwoStepModal, showFullscreenTwoStepModal, hideModal, }) => [
    {
        eventName: EVENT_TYPES.INTERNAL_EVENTS.SHOW_TWO_STEP_MODAL,
        updateFunction: showTwoStepModal,
    },
    {
        eventName: EVENT_TYPES.INTERNAL_EVENTS.HIDE_TWO_STEP_MODAL,
        updateFunction: hideModal,
    },
    {
        eventName: EVENT_TYPES.SHOW_FULLSCREEN_RLA_MODAL,
        updateFunction: showFullscreenTwoStepModal,
    },
    {
        eventName: EVENT_TYPES.HIDE_FULLSCREEN_RLA_MODAL,
        updateFunction: hideModal,
    },
];
export const getUpdateFunctionsCustomEvent = (encodedGTLibraryUrl, logoBrandName, dispatch, isReturningUser = false) => {
    return {
        showTwoStepModal: ({ detail, }) => {
            initCommonStepModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, detail);
            const shouldSkipReturningUser = detail?.skipReturningUser || false;
            const formType = isReturningUser && !shouldSkipReturningUser
                ? FORM_TYPES.TWO_STEP_RETURNING
                : FORM_TYPES.TWO_STEP_ACCOUNT_IDENTIFIER;
            dispatch(showStepModalThunk(formType));
        },
        showFullscreenTwoStepModal: ({ detail, }) => {
            initCommonStepModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, detail);
            const shouldSkipReturningUser = detail?.skipReturningUser || false;
            const formType = isReturningUser && !shouldSkipReturningUser
                ? FORM_TYPES.TWO_STEP_RETURNING
                : FORM_TYPES.TWO_STEP_ACCOUNT_IDENTIFIER;
            dispatch(showStepModalThunk(formType, true));
        },
    };
};
export const getUpdateFunctionsPubSub = (encodedGTLibraryUrl, logoBrandName, dispatch, isReturningUser = false) => {
    return {
        showTwoStepModal: (_, payload) => {
            initCommonStepModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, payload);
            const shouldSkipReturningUser = payload?.skipReturningUser || false;
            const formType = isReturningUser && !shouldSkipReturningUser
                ? FORM_TYPES.TWO_STEP_RETURNING
                : FORM_TYPES.TWO_STEP_ACCOUNT_IDENTIFIER;
            dispatch(showStepModalThunk(formType));
        },
        showFullscreenTwoStepModal: (_, payload) => {
            initCommonStepModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, payload);
            const shouldSkipReturningUser = payload?.skipReturningUser || false;
            const formType = isReturningUser && !shouldSkipReturningUser
                ? FORM_TYPES.TWO_STEP_RETURNING
                : FORM_TYPES.TWO_STEP_ACCOUNT_IDENTIFIER;
            dispatch(showStepModalThunk(formType, true));
        },
    };
};
//# sourceMappingURL=eventsSubscriptions.js.map